import { queryOptions, useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import { ReportingGetTransactionDetailDownloadRequest, ResponseError } from 'bff/client';
import { TransactionDetailResponseMock } from 'modules/clients/types/client.interfaces';
import { mockTransactionDetailResponse } from 'stores/transaction-detail-mock-data';

export const transactionDetailKeys = {
  base: () => ['transaction-detail'] as const,
  getTransactions: () => ['transaction-detail'] as const
};

// atm every client gets the same data - will use clientId with real life data
export const getTransactionDetailReport = (
  investmentNumber: number | undefined,
  _clientId: number
) => {
  return queryOptions({
    queryKey: [...transactionDetailKeys.getTransactions(), investmentNumber],
    queryFn: async (): Promise<TransactionDetailResponseMock | undefined> => {
      return mockTransactionDetailResponse.find(
        (transaction) => transaction.investmentNumber === investmentNumber
      );
    }
  });
};

export const useGetTransactionDetailDownload = (
  request: ReportingGetTransactionDetailDownloadRequest,
  options?: UseMutationOptions<Blob, ResponseError>
) => {
  const { reportingApi } = useApiClient();
  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['getTransactionDetailDownload'],
    mutationFn: async () => {
      const timeout = 15000;

      return await Promise.race([
        reportingApi.reportingGetTransactionDetailDownload(request),
        new Promise<Blob>((_, reject) =>
          setTimeout(() => reject(new Error('Timeout after 15 secs')), timeout)
        )
      ]);
    }
  };
  return useMutation(mutationOptions);
};
